import CountryPoints from './CountryPoints';
import {LangContext, CatsFilterContext} from './AppContext';
import {useContext} from 'react';

export default function Country({country}) {

  const {lang} = useContext(LangContext);
  const {catsFilter} = useContext(CatsFilterContext);

  if (catsFilter.length && country.points.findIndex(point => {
      return catsFilter.findIndex(catId => catId === point.category) !== -1;
    }) === -1){
    return null;
  }

  let x;
  switch (country.alignment) {
    case 'left':
      x = country.minX;
      break;
    case 'right':
      x = country.maxX + 32 - 150;
      break;
    default:
      x = country.minX + (country.maxX + 32 - country.minX - 150) / 2;
      break;

  }
  let y = country.position === 'top' ? country.minY - 20 : country.maxY + 35;

  return (
    <g key={country.id}>
      <CountryPoints points={country.points}/>
      <foreignObject x={x} y={y} width="150" height="30" className="pointer-events-none">
		<div className="pointer-events-none uppercase font-bold" style={{textAlign: country.alignment},{display: 'none'}}>{country[`name_${lang}`]}</div>
      </foreignObject>
    </g>
  )
}
